// 数据统计看板
const DataDashboardRouter = {
  path: 'dataDashboard',
  name: 'DataDashboard',
  meta: {
    requiresAuth: false,
    leftMenu: true
  },
  component: () => import('@/views/Dashboard/index')
}
export default DataDashboardRouter
